import type { Recurrence } from "../../../shared/tools.ts";
import { fromLocalInput, parseReminders } from "./format.ts";

/** What the task form edits; the rest of a recurrence rule (weekdays, until, count) is kept from the saved task. */
export type TaskDraft = { id?: string; revision?: number; title: string; details: string; due: string; timezone: string; reminders: string; freq: "" | Recurrence["freq"]; interval: string };
type Existing = { dueAt: string | null; recurrence: Recurrence | null };

/**
 * The action arguments for a draft. Editing never drops the parts of a rule the form cannot show,
 * and clearing the due field on a saved task sends `null` so the server clears it (an omitted
 * `dueAt` means "keep").
 */
export type TaskArgs = { title: string; details: string; dueAt?: string | null; timezone: string; reminders: number[]; recurrence: Recurrence | null };
export function taskArgsFromDraft(draft: TaskDraft, existing?: Existing): TaskArgs {
  const interval = Number(draft.interval);
  const recurrence: Recurrence | null = draft.freq
    ? { ...(existing?.recurrence ?? {}), freq: draft.freq, ...(interval > 1 ? { interval } : {}) }
    : null;
  if (recurrence && !(interval > 1)) delete (recurrence as { interval?: number }).interval;
  const dueAt = fromLocalInput(draft.due, draft.timezone);
  return {
    title: draft.title,
    details: draft.details,
    ...(dueAt ? { dueAt } : existing?.dueAt && draft.id ? { dueAt: null } : {}),
    timezone: draft.timezone,
    reminders: parseReminders(draft.reminders),
    recurrence,
  };
}
